import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import hospitalsInfo from './modules/hospitalsInfo';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    user,
    hospitalsInfo
  }
});